import { render, staticRenderFns } from "./OutcomeCounts.vue?vue&type=template&id=64b49569"
import script from "./OutcomeCounts.vue?vue&type=script&lang=js"
export * from "./OutcomeCounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports